'use client';

import { c as _c } from "react/compiler-runtime";
import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { useWebsitePagesCopy } from '@/lib/cadrino-landing/useWebsitePagesCopy';
import { Container, Section, SectionHeader, MotionBlock, ContentCard, CardTitle, PrimaryButton, SecondaryButton, SectionActions, FeatureDetail, cardGridClass } from './shared';
export function FeaturesSection() {
  const $ = _c(21);
  const c = useCadrinoCopy();
  const pages = useWebsitePagesCopy();
  let t0;
  if ($[0] !== c.features.subtitle || $[1] !== c.features.title) {
    t0 = <MotionBlock><SectionHeader title={c.features.title} subtitle={c.features.subtitle} /></MotionBlock>;
    $[0] = c.features.subtitle;
    $[1] = c.features.title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== c.features.items || $[4] !== c.features.labels) {
    let t2;
    if ($[6] !== c.features.labels) {
      t2 = (f, i) => <MotionBlock key={f.title} delay={i * 0.04}><ContentCard><CardTitle>{f.title}</CardTitle><dl className="mt-4 flex flex-1 flex-col gap-4"><FeatureDetail label={c.features.labels.problem} accent="problem">{f.problem}</FeatureDetail><FeatureDetail label={c.features.labels.behavior} accent="behavior">{f.behavior}</FeatureDetail><FeatureDetail label={c.features.labels.outcome} accent="outcome">{f.outcome}</FeatureDetail></dl></ContentCard></MotionBlock>;
      $[6] = c.features.labels;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = c.features.items.map(t2);
    $[3] = c.features.items;
    $[4] = c.features.labels;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <div className={cardGridClass}>{t1}</div>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== pages.nav.product) {
    t3 = <PrimaryButton href="/product">{pages.nav.product}</PrimaryButton>;
    $[10] = pages.nav.product;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== c.nav.bookDemo) {
    t4 = <SecondaryButton href="#contact">{c.nav.bookDemo}</SecondaryButton>;
    $[12] = c.nav.bookDemo;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <MotionBlock><SectionActions>{t3}{t4}</SectionActions></MotionBlock>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t0 || $[18] !== t2 || $[19] !== t5) {
    t6 = <Section><Container>{t0}{t2}{t5}</Container></Section>;
    $[17] = t0;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}